import { FontAwesome5 } from '@expo/vector-icons';
import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { OEText } from '../../atoms/oe-text/oe-text';
import { flex, padding } from '../../style-utils';

type PaginationButtonType = {
  onPress: () => void;
  text: string;
};

export interface PaginationButtonsProps {
  prev?: PaginationButtonType;
  next?: PaginationButtonType;
  color?: string;
}

export const PaginationButtons = ({
  prev,
  next,
  color,
}: PaginationButtonsProps) => {
  if (!prev && !next) {
    return null;
  }

  return (
    <View
      style={[flex('flex-row', 'justify-content-center', 'align-items-center')]}
    >
      <View style={[flex('flex-1', 'align-items-end')]}>
        {!!prev && (
          <TouchableOpacity onPress={prev.onPress} style={buttonStyle}>
            <ArrowIcon name="chevron-left" color={color} />
            <ButtonText color={color}>{prev.text}</ButtonText>
          </TouchableOpacity>
        )}
      </View>
      <View style={[flex('flex-1', 'align-items-start')]}>
        {!!next && (
          <TouchableOpacity onPress={next.onPress} style={buttonStyle}>
            <ButtonText color={color}>{next.text}</ButtonText>
            <ArrowIcon name="chevron-right" color={color} />
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
};

const buttonStyle = [flex('flex-row', 'align-items-center'), padding(15)];

const ButtonText = styled(OEText).attrs(({ theme, color }) => ({
  color: color || theme.color.primary,
  size: 14,
  fontFamily: secondaryFontFamily,
  fontType: 'medium',
}))`
  padding-bottom: 1px;
`;

const ArrowIcon = styled(FontAwesome5).attrs(({ theme, color }) => ({
  color: color || theme.color.primary,
  size: 12,
}))`
  padding-horizontal: 4px;
`;
